const GraphQLForm = require('app/graphql/Form');

class PriceAndStockForm extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'CopyPriceAndStockRestaurant',
            'restaurant': null,
            'restaurants': [],
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.restaurant = this.settings.restaurant;
        this.restaurants = this.settings.restaurants;

        this.buildForm();

        super.initialize();
    }

    getRestaurant(){
        return this.restaurant;
    }

    getForm(){
        return this.$form;
    }

    buildForm(){

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-success')
        .append(window.translate('app.restaurant.show.tabs.copy.submit.label'));

        this.$form = $('<form/>')
        .addClass('restaurant-info-form')
        .addClass('white-box')
        .append(this.buildInputs())
        .append(
            $('<div/>')
            .append(this.$btnSubmit)
        );

        return this.$form;
    }

    buildInputs(){

        let $box = $('<div/>');

        //LABEL
        let $label = $('<h3/>')
        .addClass('box-title')
        .append(window.translate('app.restaurant.show.tabs.copy.priceAndStockForm.label'))
        .appendTo($box);


        //FIELD target
        let $targetLabel = $('<label/>')
        .attr('for','target')
        .append(window.translate('app.restaurant.show.tabs.copy.priceAndStockForm.target.label'));
        let $targetDescription = $('<div/>')
        .append(
            $('<small/>')
            .addClass('text-muted')
            .append(window.translate('app.restaurant.show.tabs.copy.priceAndStockForm.target.warning'))
        );

        this.$targetSelect = $('<select/>')
        .attr('name','target')
        .attr('required','required')
        .addClass('form-control')
        .append(
             $('<option/>')
             .val('')
             .append('-')
        );

        for(var i in this.restaurants){
            let restaurantItem = this.restaurants[i];

            let value = restaurantItem.node.id;
            let label = restaurantItem.node.name;

            let $option = $('<option/>')
            .val(value)
            .append(label);

            this.$targetSelect.append($option);
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($targetLabel)
            .append(this.$targetSelect)
            .append($targetDescription)
        );

        //FIELD replaceBookmark
        let $replaceBookmarkLabel = $('<label/>')
        .attr('for','replaceBookmark')
        .append(window.translate('app.restaurant.show.tabs.copy.priceAndStockForm.replaceBookmark.label'));
        let $replaceBookmarkDescription = $('<div/>')
        .append(
            $('<small/>')
            .addClass('text-muted')
            .append(window.translate('app.restaurant.show.tabs.copy.priceAndStockForm.replaceBookmark.warning'))
        );

        this.$replaceBookmarkCheckbox = $('<input/>')
        .attr('type','checkbox')
        .attr('id','replaceBookmark')
        .attr('name','replaceBookmark')
        .val('1');

        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append(this.$replaceBookmarkCheckbox)
            .append(' ')
            .append($replaceBookmarkLabel)
            .append($replaceBookmarkDescription)
        );

        


        return $box;
    }

    onDOMReady(){
        super.onDOMReady();
        this.$targetSelect.select2();
    }

    getFields(){
        let fields = super.getFields();
        return fields;
    }
    
    getVariables(){
        let variables = {};

        variables.restaurant = {
            'value': this.restaurant.id,
            'type': 'Int!'
        };

        return variables;
    }


}

module.exports = PriceAndStockForm;

